import React from 'react'

const AboutPage = () => (
  <div className="issue">
    <div className="sideBarLeft">
      <div className="impressum">
        <ul>
          <li><a href={`/about/`}>about</a></li>
          <li><a href={`/editorial/`}>editorial</a></li>
          <li><a href={`/contact/`}>contact</a></li>
        </ul>
      </div>
      <div className="archive">
        <a href="/archive/">archive</a>
      </div>
    </div>
    <div className="core-content">
      <h2>this is a monthly electronic art magazine. each issue is dedicated to a different topic.</h2>
      <h2><a href="http://creativecommons.org/licenses/by-nc-sa/2.0/"><img id="license" src="/style/default/somerights20.png" alt="creativecommons license" border="0" /></a> its users are its artists.</h2>
      <h3>e-zine:format</h3>
      <p>the e-zine invites creative interpretations of a monthly changing topic. all submitted works are published indiscriminately. the contributors are free in their choice of form: graphic design, photography, movies, cartoons, texts, etc. the upload is carried out individually and the maximum space per submission is 400x400 pixels. the contributions are published under free copyright license.</p>
      <h3>i-love-u:idea</h3>
      <p>in 1997 the first issue "ass" of the e-zine was release by the i-love-u multimedia collective: basel, london, barcelona. the e-zine is conceived as an experimental platform, simple in use as a printed magazine. its approach to creative expression is openminded and playfully provocative. it furthers immediate and dynamic artistic production and its distribution is world wide.</p>
      <h3>i-love-u:layout</h3>
      <p>for designing a love-layout please <a href="mailto:layout@i-love-u.ch">e-mail us</a> ideas and drafts.</p>
    </div>
    <div className="nav-and-metadata">
    </div>
  </div>
)

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/about.js